import { useDataChange } from 'Simple/Data.js'

export function useOnClickFixed(props) {
  let change = useDataChange({
    context: 'settings',
    path: 'data.minimum_downpayment.type',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change('FIXED')
  }
}

export function useOnClickPercentage(props) {
  let change = useDataChange({
    context: 'settings',
    path: 'data.minimum_downpayment.type',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change('PERCENTAGE')
  }
}
